export function isHTML(str: string) {
  const element = document.createElement('div');
  element.innerHTML = str;

  for (let content = element.childNodes, i = content.length; i--; ) {
    if (content[i].nodeType === 1) return true;
  }

  return false;
}

export const parseHTML = (() => {
  const rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi;
  const rtagName = /<([\w:]+)/;
  const rhtml = /<|&#?\w+;/;
  // We have to close these tags to support XHTML (#13200)
  const wrapMap = {
    // Support: IE9
    option: [1, '<select multiple="multiple">', '</select>'],

    thead: [1, '<table>', '</table>'],
    col: [2, '<table><colgroup>', '</colgroup></table>'],
    tr: [2, '<table><tbody>', '</tbody></table>'],
    td: [3, '<table><tbody><tr>', '</tr></tbody></table>'],

    default: [0, '', ''],
  };

  /**
   * @param {String} elem A string containing html
   */
  return function parseHTML(elem: string) {
    if (!isHTML(elem)) return elem;

    let tmp;
    let tag;
    let wrap;
    let j;
    const fragment = document.createDocumentFragment();

    if (!rhtml.test(elem)) {
      fragment.appendChild(document.createTextNode(elem));

      // Convert html into DOM nodes
    } else {
      tmp = fragment.appendChild(document.createElement('div'));

      // Deserialize a standard representation
      tag = (rtagName.exec(elem) || ['', ''])[1].toLowerCase();
      // @ts-ignore
      wrap = wrapMap[tag] || wrapMap.default;
      tmp.innerHTML = wrap[1] + elem.replace(rxhtmlTag, '<$1></$2>') + wrap[2];

      // Descend through wrappers to the right content
      j = wrap[0];
      while (j--) {
        tmp = tmp!.lastChild;
      }

      // Remove wrappers and append created nodes to fragment
      fragment.removeChild(fragment.firstChild!);
      while (tmp!.firstChild) {
        fragment.appendChild(tmp!.firstChild);
      }
    }

    return fragment.textContent;
  };
})();
